import { actionTypes } from "./actions";

const initialState = {
  data: [],
  productEdit: {},
  editProductLoader: false
};

export default (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {
    case actionTypes.SET_PRODUCTS:
      return {
        ...state,
        data: payload,
      };
    case actionTypes.SET_PRODUCT_BY_ID:
      return {
        ...state,
        productEdit: payload
      }
    case actionTypes.SET_EDIT_PRODUCT_LOADER:
      return {
        ...state,
        editProductLoader: payload
      }

    default:
      return {
        ...state,
      };
  }
};
